var map = {
	"./results-0percent.jpg": 346,
	"./results-100percent.jpg": 841,
	"./results-10percent.jpg": 859,
	"./results-15percent.jpg": 360,
	"./results-20percent.jpg": 388,
	"./results-25percent.jpg": 23,
	"./results-30percent.jpg": 33,
	"./results-35percent.jpg": 254,
	"./results-40percent.jpg": 882,
	"./results-45percent.jpg": 261,
	"./results-50percent.jpg": 655,
	"./results-55percent.jpg": 324,
	"./results-5percent.jpg": 157,
	"./results-60percent.jpg": 632,
	"./results-65percent.jpg": 779,
	"./results-70percent.jpg": 301,
	"./results-75percent.jpg": 106,
	"./results-80percent.jpg": 526,
	"./results-85percent.jpg": 334,
	"./results-90percent.jpg": 160,
	"./results-95percent.jpg": 736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;